import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'react-bootstrap5';

import StepSessionSummary from './Widgets/StepSessionSummary';
import StepStatic from './Widgets/StepStatic';

export default function Summary({ data }) {
  return (
    <>
      <p>
        Your Program -
        {' '}
        {data.programName}
      </p>

      <Row className="mt-5">
        <Col md={{ span: 6, offset: 3 }}>
          <div className="label mb-3" />

          <div className="selected-topics-wrapper counting-icons-wrapper">
            <StepStatic
              key="step-first-cpa"
              title="First Talent Assessment"
              iconClass="career-pulse-assessment-icon"
            />

            <StepSessionSummary
              key="session-step-1"
              assignTopic={data.sessionsTopics.find((item) => item.position === 1)?.topic}
            />

            <StepStatic key="step-coach-feedback" title="Coach Feedback" iconClass="star-filled-icon" />

            {Array.from(Array(data.countSessions - 1)).map((_x, i) => (
              <React.Fragment key={`session-step-${i + 2}`}>
                {data.countSessions !== 3 && i === data.countSessions - 2
                      && (
                      <StepStatic
                        title="Final Talent Assessment"
                        iconClass="career-pulse-assessment-icon"
                      />
                      )}
                <StepSessionSummary
                  assignTopic={data.sessionsTopics.find((item) => item.position === i + 2)?.topic}
                />

                {data.countSessions === 12 && i === 4 && (
                  <StepStatic
                    title="Mid-Program Talent Assessment"
                    iconClass="career-pulse-assessment-icon"
                  />
                )}
              </React.Fragment>
            ))}

            {data.countSessions === 3
                  && (
                  <StepStatic
                    key="step-final-cpa-2"
                    title="Final Talent Assessment"
                    iconClass="career-pulse-assessment-icon"
                  />
                  )}

            <StepStatic key="step-program-feedback" title="Program End Survey" iconClass="star-filled-icon" />
          </div>
        </Col>
      </Row>
    </>
  );
}

Summary.propTypes = {
  data: PropTypes.object.isRequired,
};
